import { useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/material/styles';

/**
 * Which layout a screen adapts to, one flag per decision so every feature switches at the same width:
 * - `isPhone` (<600): single-column dialogs, toasts, chat spacing.
 * - `isCompact` (<900): one pane at a time, full-screen hosting dialogs, the desktop notice, side sheets on
 *   the investigation screen.
 * - `isDesktop` (>=1200): a full-width master list beside its detail, and the event screens' filter rail
 *   beside the table rather than in a drawer.
 * - `isTouch`: a coarse pointer, so small icon buttons grow to a finger-sized target, tooltips show on a tap
 *   (`TapTooltip`) and Enter in the chat box inserts a newline rather than sending (`ChatInput`).
 */
export interface Viewport {
  isPhone: boolean;
  isCompact: boolean;
  isDesktop: boolean;
  isTouch: boolean;
}

export function useViewport(): Viewport {
  const theme = useTheme();
  const isPhone = useMediaQuery(theme.breakpoints.down('sm'));
  const isCompact = useMediaQuery(theme.breakpoints.down('md'));
  const isDesktop = useMediaQuery(theme.breakpoints.up('lg'));
  const isTouch = useMediaQuery('(pointer: coarse)');
  return { isPhone, isCompact, isDesktop, isTouch };
}
